import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import Select from 'react-select';
// import { Formik, Form, Field } from 'formik';

import RegistryTable from '../shared/RegistryTable_RT';
import PeriodAndDisplaySelector from '../shared/PeriodAndDisplaySelector';
import ItemMultiSelector from '../shared/ItemMultiSelector';

import * as api from '../../api/api';
import * as utils from '../../utils';

class LogPage extends React.Component {
    constructor(props) {
        super(props);

        this.eventTypes = [
            { value: '0', label: 'Ошибка' },
            { value: '1', label: 'Предупреждение' },
            { value: '2', label: 'Информация' }
        ];

        this.state = {
            logs: [],
            selectedEventTypes: this.eventTypes.map((type) => (type.value)),
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        this.getFilteredLogs = this.getFilteredLogs.bind(this);
        this.onMount = this.onMount.bind(this);
    }

    componentDidMount() {

        // api.makeRequest(api.getDisplaysDictionary()).then(
        //     (response) => {

        //         filterOptions: {
        //             displaysId: this.props.match.params.displayId ? 
        //             [{
        //                 value: this.props.match.params.displayId,
        //                 label: this.props.match.params.displayId
        //             }] : []
        //         }

        //         let displays;
        //         let selectedDisplay;

        //         if (this.props.match.params.displayId) {
        //             displays = response.data.data.map((item, i) => {

        //                 if (item.id == this.props.match.params.displayId) {
        //                     selectedDisplay = {
        //                         value: item.id,
        //                         label: item.name
        //                     }
        //                 }

        //                 return {
        //                     value: item.id,
        //                     label: item.name
        //                 };
        //             });
        //         } else {
        //             displays = response.data.data.map((item, i) => {
        //                 return {
        //                     value: item.id,
        //                     label: item.name
        //                 };
        //             });
        //         }

        //         let filterOptions = {
        //             displays_id: selectedDisplay ? [selectedDisplay.value] : [],
        //             from: '',
        //             to: '',
        //             event_types_id: []
        //         };

        //         this.processGetLogsResponse(api.getFilteredLogs(filterOptions));

        //         this.setState({
        //             displays: displays,
        //             eventTypes: [
        //                 { value: '0', label: 'Информация' },
        //                 { value: '1', label: 'Предупреждение' },
        //                 { value: '2', label: 'Ошибка' }
        //             ],
        //             filterOptions: {
        //                 displaysId: selectedDisplay ? [selectedDisplay] : []
        //             }
        //         });

        //         this.eventTypes = [
        //             { value: '0', label: 'Информация' },
        //             { value: '1', label: 'Предупреждение' },
        //             { value: '2', label: 'Ошибка' }
        //         ];

        //         this.props.updateLoader({
        //             loaded: true,
        //             message: ""
        //         });
        //     },
        //     (error) => {
        //         this.props.updateLoader({
        //             loaded: true,
        //             message: "Ошибка при получении списка табло: " + error
        //         });
        //     }
        // );
    }

    onMount() {
        this.getFilteredLogs();
    }

    getFilteredLogs() {

        let errors = [];

        if (!this.state.startDate || !this.state.endDate || !this.state.displays || this.state.displays.length === 0
            || !this.state.selectedEventTypes || this.state.selectedEventTypes.length === 0) {

            if (!this.state.startDate || !this.state.endDate) {
                errors.push(<li className="mb-2">Пожалуйста, выберите корректный период</li>);
            }

            if (!this.state.displays || this.state.displays.length === 0) {
                errors.push(<li className="mb-2">Пожалуйста, выберите табло</li>);
            }

            if (!this.state.selectedEventTypes || this.state.selectedEventTypes.length === 0) {
                errors.push(<li className="mb-2">Пожалуйста, выберите типы сообщений</li>);
            }

            this.setState({
                errors: errors
            });

            return;
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        api.makeRequest(api.getFilteredLogs({
            from: this.state.startDate,
            to: this.state.endDate,
            devices: this.state.displays,
            // event_types_id: this.state.eventTypes.map(item => { return item.value })
            levels: this.state.selectedEventTypes,
        })).then(
            (response) => {
                // console.log(response.data.data);
                this.setState({
                    logs: response.data.data.map((item, i) => {

                        // const dt = new Date(item.dateTime);

                        return {
                            id: item.id,
                            number: i + 1,
                            device: item.device,
                            checkpoint: item.checkpoint,
                            level: item.level,
                            // dateTime: utils.formatDate(dt),
                            dateTime: item.dateTime,
                            message: item.message
                        }
                    }),
                    reportPeriodText: "Показаны данные за " + this.state.startDate + " - " + this.state.endDate,
                    errors: null
                });

                this.props.updateLoader({
                    loaded: true
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + error
                });

                this.setState({
                    reportPeriodText: "Показаны данные за " + this.state.startDate + " - " + this.state.endDate,
                    errors: null
                });
            }
        );
    }

    resetFilters(callback) {
        callback();

        this.setState({
            filterOptions: {
                displaysId: [],
                from: '',
                to: '',
                eventTypesId: []
            },
        }, () => {
            this.getFilteredLogs(this.state.filterOptions)
        });
    }

    render() {

        const displaySelectStyle = {
            control: styles => ({ ...styles, minWidth: '250px' })
        };

        const eventTypeSelectStyle = {
            control: styles => ({ ...styles, minWidth: '250px' })
        };

        const columns = [
            {
                Header: '_id',
                accessor: 'id',
            },
            {
                Header: '#',
                accessor: 'number',
            },
            {
                Header: 'Табло',
                accessor: 'device',
            },
            {
                Header: 'Остановочный пункт',
                accessor: 'checkpoint',
            },
            {
                Header: 'Тип сообщения',
                accessor: 'level',
            },
            {
                Header: 'Время',
                accessor: 'dateTime',
            },
            {
                Header: 'Содержание',
                accessor: 'message',
            }
        ];

        return (
            // <div style={{ width: 80 + 'vw' }}>
            <div>
                <div className="card card-collapse">
                    <div className="card-header">
                        <h5>
                            <a data-toggle="collapse" href="#filterBlock">
                                Фильтр
                            </a>
                        </h5>
                    </div>

                    <div className="collapse show" id="filterBlock">
                        <div className="card-body">

                            <PeriodAndDisplaySelector
                                onDatesChange={(startDate, endDate) => { this.setState({ startDate, endDate }) }}
                                onDisplaysChange={(displays) => { this.setState({ displays }) }}
                                updateLoader={this.props.updateLoader}
                                onMount={this.onMount}
                            />

                            {/* <div className="mt-3">
                                <label>Типы сообщений</label>
                                <Select
                                    isMulti
                                    placeholder="Щёлкните для выбора..."
                                    options={this.eventTypes}
                                    value={this.state.eventTypes}
                                    onChange={(value) => this.setState({ eventTypes: value })}
                                />
                            </div> */}

                            <ItemMultiSelector
                                caption="Типы сообщений"
                                items={this.eventTypes}
                                // onItemsChange={(value) => this.setState({ eventTypes: value })}
                                onItemsChange={(value) => {
                                    // console.log(value);
                                    this.setState({ selectedEventTypes: value })
                                }}
                            />

                            {
                                this.state.errors &&
                                <div className="alert alert-warning p-2 mt-3" role="alert">
                                    Обнаружены ошибки:
                                    <ul className="mt-3">
                                        {this.state.errors}
                                    </ul>
                                </div>
                            }

                            <div className="d-flex justify-content-center mt-2">
                                <button className="btn btn-primary-custom" onClick={this.getFilteredLogs}>
                                    Применить
                                </button>
                            </div>

                            {/* <Formik
                                initialValues={this.state.filterOptions}
                                enableReinitialize={true}
                                onSubmit={(values, { setSubmitting }) => {
                                    this.getFilteredLogs(values);
                                }}
                            >
                                {({ isSubmitting,
                                    setFieldValue,
                                    values,
                                    resetForm
                                }) => (
                                        <Form>
                                            <div className="form-group ml-3">
                                                <label>Табло</label>
                                                <Select
                                                    isMulti
                                                    options={this.state.displays}
                                                    value={values.displaysId}
                                                    onChange={(value) => setFieldValue("displaysId", value)}
                                                // styles={displaySelectStyle}
                                                />
                                            </div>
                                            <div className="form-group ml-3">
                                                <label>Типы сообщений</label>
                                                <Select
                                                    isMulti
                                                    options={this.state.eventTypes}
                                                    value={values.eventTypesId}
                                                    onChange={(value) => setFieldValue("eventTypesId", value)}
                                                // styles={eventTypeSelectStyle}
                                                />
                                            </div>
                                            <div className="form-group ml-3">
                                                <label>Сообщения с</label>
                                                <Field className="form-control" type="date" name="from" />
                                            </div>

                                            <div className="form-group ml-3">
                                                <label>Сообщения по</label>
                                                <Field className="form-control" type="date" name="to" />
                                            </div>
                                            <div className="d-flex justify-content-center mt-2">
                                                <button className="btn btn-primary-custom" type="submit">
                                                    Применить
                                            </button>
                                                <button className="btn btn-secondary ml-3" type="button" onClick={() => this.resetFilters(resetForm)}>
                                                    Сбросить
                                            </button>
                                            </div>
                                        </Form>
                                    )}
                            </Formik> */}
                        </div>
                    </div>
                </div>

                <div className="card mt-5">
                    <div className="card-header">
                        <h5>Реестр событий</h5>
                    </div>

                    <div className="card-body">

                        {
                            this.state.reportPeriodText &&
                            <div class="alert alert-info mt-3 mb-3" role="alert">
                                {this.state.reportPeriodText}
                            </div>
                        }

                        <RegistryTable
                            columns={columns}
                            data={this.state.logs}
                            showActions={false}
                            alwaysDisplayTable={false}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default LogPage;